import React, { Component } from 'react';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';
import BzmNumericInput from 'components/forms/BzmNumberInput/BzmNumericInput';
import _ from 'lodash';

type BzmTimeRangePickerStateProps = {
  timeFrom: TimeRange;
  timeTo: TimeRange;
  onTimeRangeChanged: (timeFrom: TimeRange, timeTo: TimeRange) => void;
  disableButton?: boolean;
  useRangeValidation: boolean;
  exposeCurrentTime: (timeFrom: TimeRange, timeTo: TimeRange) => void;
};

type AllProps = BzmTimeRangePickerStateProps;

export enum HourMode {
  AM = 'AM',
  PM = 'PM',
}

export type TimeRange = {
  hours: number;
  minutes: number;
  mode: HourMode;
};

class BzmTimeRangePicker extends Component<AllProps> {
  state = {
    timeFrom: this.props.timeFrom,
    timeTo: this.props.timeTo,
    invalidTimeRange: false,
  };

  verifyRange = () => {
    let badRange = false;
    const hourTo = this.state.timeTo.hours !== 12 ? this.state.timeTo.hours : 0;
    const hourFrom = this.state.timeFrom.hours !== 12 ? this.state.timeFrom.hours : 0;
    if (this.state.timeFrom.mode === 'PM' && this.state.timeTo.mode === 'AM') {
      badRange = true;
    }
    if (!badRange) {
      if (this.state.timeFrom.mode === this.state.timeTo.mode) {
        if (hourFrom > hourTo || (hourFrom === hourTo && this.state.timeFrom.minutes >= this.state.timeTo.minutes)) {
          badRange = true;
        }
      }
    }
    this.setState({ invalidTimeRange: badRange });
  };

  onInputChange = (key: any, value: any) => {
    this.setState(
      {
        [key]: value,
      },
      () => {
        this.verifyRange();
        this.props.exposeCurrentTime(this.state.timeFrom, this.state.timeTo);
      },
    );
  };

  render() {
    const createTimePicker = (timePicker: string) => {
      let time: TimeRange;
      if (timePicker === 'timeFrom') {
        time = this.state.timeFrom;
      } else {
        time = this.state.timeTo;
      }

      return (
        <div className="text-center">
          <BzmNumericInput
            min={1}
            max={12}
            value={time.hours}
            onChange={value => this.onInputChange(timePicker, { hours: value, minutes: time.minutes, mode: time.mode })}
          />

          <BzmNumericInput
            min={0}
            max={59}
            value={time.minutes}
            onChange={value => this.onInputChange(timePicker, { hours: time.hours, minutes: value, mode: time.mode })}
            format={(value: number | null) => {
              return value !== null ? _.padStart(value.toString(), 2, '0') : '0';
            }}
          />

          <ButtonGroup>
            {Object.values(HourMode).map(mode => {
              let variant: 'primary' | 'secondary';
              if (mode === 'AM') {
                variant = time.mode === HourMode.AM ? 'primary' : 'secondary';
              } else {
                variant = time.mode === HourMode.PM ? 'primary' : 'secondary';
              }

              return (
                <Button
                  key={mode}
                  onClick={() =>
                    this.onInputChange(timePicker, { hours: time.hours, minutes: time.minutes, mode: mode })
                  }
                  variant={variant}
                  style={{ position: 'relative', bottom: '1px' }}
                >
                  <span>{mode}</span>
                </Button>
              );
            })}
          </ButtonGroup>
        </div>
      );
    };

    return (
      <div>
        <Row style={{ margin: 'auto' }}>
          <Col md={5} sm={12}>
            {createTimePicker('timeFrom')}
          </Col>
          <Col md={2}>
            <hr />
          </Col>
          <Col md={5} sm={12}>
            {createTimePicker('timeTo')}
          </Col>
        </Row>
        <div className="text-right" style={{ position: 'relative', top: '20px', height: 78, paddingTop: '12px' }}>
          <ButtonGroup className="inline-block mr-4">
            <Button
              onClick={() => {
                document.dispatchEvent(new MouseEvent('click'));
              }}
              className="btn-link btn-no-hover"
              variant={'link'}
              title={'Cancel'}
              style={{ height: '30px' }}
            >
              <span className="ml-2">Cancel</span>
            </Button>
            <Button
              onClick={() => this.props.onTimeRangeChanged(this.state.timeFrom, this.state.timeTo)}
              variant={'primary'}
              title={'Save selected days'}
              style={{ height: '30px' }}
              disabled={this.props.disableButton || (this.props.useRangeValidation && this.state.invalidTimeRange)}
            >
              <span className="ml-2">Save</span>
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  }
}

export default BzmTimeRangePicker;
